export default __webpack_public_path__ + "static/media/bg-banner-6.de883ca9.jpg";